var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":'vword' + this.facetCode}},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('span',{staticClass:"loading-spinner spinner-lg"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }